export default "__VITE_ASSET__DR_vU9rb__"